import * as types from '../actions/types';
import _ from 'lodash';

const initialState = {
  'meta': {},
  'header': {},
  'banner': {},
  'guide': {},
  'notice': {},
  'show': {},
  'view': {}
};

let newState = null;

const pageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_IN_QUIZ:
      newState = _.clone(state);
      newState.inQuiz = action.state;
      return newState;

    case types.TOGGLE_IN_RESULTS:
      newState = _.clone(state);
      newState.inResults = action.state;
      return newState;

    case types.UPDATE_TOP_BANNER:
      newState = _.clone(state);
      newState.header.topBanner = action.topBanner;
      return newState;

    case types.UPDATE_HEADER_HOURS:
      newState = _.clone(state);
      newState.header.hours = action.hours;
      return newState;

    case types.UPDATE_HEADER_PHONE:
      newState = _.clone(state);
      newState.header.phone = action.phone;
      return newState;

    case types.UPDATE_HEADER_PREMIUM:
      newState = _.clone(state);
      newState.header.premium = action.premium;
      return newState;

    case types.UPDATE_HEADER_SCROLLER:
      newState = _.clone(state);
      newState.header.scrollButton = action.scrollButton;
      return newState;

    case types.UPDATE_RESULTS_RATINGS:
      newState = _.clone(state);
      newState.show.ratings = action.ratings;
      newState.show.ratingsProps = action.ratingsProps;
      return newState;

    case types.UPDATE_RESULTS_FOOTER:
      newState = _.clone(state);
      newState.show.footer = action.footer;
      newState.show.footerProps = action.footerProps;
      return newState;

    default:
      return state;
  }
};

export default pageReducer;
